import axios from 'axios';
import apiConfig from '~Configs/apiConfig';

export const traceAxiosInstance = axios.create({
  baseURL: apiConfig.traceApiUrl,
  headers: {},
});
